import { http } from "../../utils/config";

const mapZnsAPI = {
  getMapZnss: (params = {}) => {
    const {
      page = 1,
      per_page = 15,
      search = "",
      status = "",
      sort_by = "created_at",
      sort_order = "desc",
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      sort_by,
      sort_order,
      ...(search && { search }),
      ...(status !== "" && { status }),
    });

    return http.get(`/api/v1/zns/map?${queryParams}`);
  },

  getEventZnsAll: () => {
    return http.get(`/api/v1/zns/events/all`);
  },

  // Create new
  createMapZns: (mapZnsData) => {
    return http.post("/api/v1/zns/map", mapZnsData);
  },

  // Update
  updateMapZns: (id, mapZnsData) => {
    return http.put(`/api/v1/zns/map/${id}`, mapZnsData);
  },

  deleteMapZns: (id) => {
    return http.delete(`/api/v1/zns/map/${id}`);
  },

  // Update
  // sendOneZns: (id, customerId) => {
  //   return http.post(`/api/v1/zns/collections/${id}/send-one/${customerId}`);
  // },

  sendOneZns: (id) => {
    return http.post(`/api/v1/zns/collections/send-one/${id}`);
  },

  sendAllZns: (id) => {
    return http.post(`/api/v1/zns/collections/${id}/send-all`);
  },

  sendAllParent: (id) => {
    return http.post(`/api/v1/zns/collections/parent/${id}/send-all`);
  },

  // resendOneZns: (id, customerId) => {
  //   return http.post(`/api/v1/zns/collections/${id}/resend-one/${customerId}`);
  // },
  
  resendOneZns: (id) => {
    return http.post(`/api/v1/zns/collections/resend-one/${id}`);
  },

  resendAllZns: (id) => {
    return http.post(`/api/v1/zns/collections/${id}/resend-all`);
  },

  resendAllParent: (id) => {
    return http.post(`/api/v1/zns/collections/parent/${id}/resend-all`);
  },

  // Đếm trước cho hộp thoại gửi cả đợt: { unsent, all, already_sent, blocked_reason }
  sendableCount: (id) => {
    return http.get(`/api/v1/zns/collections/${id}/sendable-count`);
  },

  sendableCountParent: (id) => {
    return http.get(`/api/v1/zns/collections/parent/${id}/sendable-count`);
  },

  getHistories: (params = {}) => {
    const {
      page = 1,
      per_page = 15,
      search = "",
      status = "",
      type = "",
      send_status = "",
      error_reason = "",
      sort_by = "created_at",
      sort_order = "desc",
      customer_fee_id,
      collection_id,
      organization_id,
      from_date,
      to_date,
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      sort_by,
      sort_order,
      ...(customer_fee_id && { customer_fee_id }),
      ...(collection_id && { collection_id }),
      ...(organization_id && { organization_id }),
      ...(search && { search }),
      ...(type && { type }),
      ...(send_status && { send_status }),
      ...(error_reason && { error_reason }),
      ...(status !== "" && { status }),
      ...(from_date && { from_date }),
      ...(to_date && { to_date }),
    });

    return http.get(`/api/v1/logs/zns?${queryParams}`);
  },

  getTemplate: (params = {}) => {
    const { template_id = "" } = params;

    const queryParams = new URLSearchParams({
      ...(template_id && { template_id }),
    });

    return http.get(`/api/v1/zns/templates?${queryParams}`);
  },

  getAvailableVariableAliases: (params = {}) => {
    const { event_id = "" } = params;

    const queryParams = new URLSearchParams({
      ...(event_id && { event_id }),
    });

    return http.get(`/api/v1/zns/map/available-variable-aliases?${queryParams}`);
  },

  // sendOneCampaignZns: (id, customerId) => {
  //   return http.post(`/api/v1/zns/campaigns/${id}/send-one/${customerId}`);
  // },
  sendOneCampaignZns: (id) => {
    return http.post(`/api/v1/zns/campaigns/send-one/${id}`);
  },

  sendAllCampaignZns: (id) => {
    return http.post(`/api/v1/zns/campaigns/${id}/send-all`);
  },

  sendAllParentCampaign: (id) => {
    return http.post(`/api/v1/zns/campaigns/parent/${id}/send-all`);
  },
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response;
    } catch (error) {
      console.error("API Error:", error);

      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        const { status, data } = error.response;
        switch (status) {
          case 400:
            throw new Error(data.message || "Dữ liệu không hợp lệ");
          case 401:
            throw new Error("Bạn cần đăng nhập để thực hiện thao tác này");
          case 403:
            throw new Error("Bạn không có quyền thực hiện thao tác này");
          case 404:
            throw new Error("Không tìm thấy thông tin");
          case 422:
            throw new Error(data.message || "Dữ liệu không hợp lệ");
          case 500:
            // throw new Error("Lỗi server, vui lòng thử lại sau");
            throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default:
            throw new Error(data.message || "Đã có lỗi xảy ra");
        }
      } else if (error.request) {
        // Network error
        throw new Error("Không thể kết nối đến server");
      } else {
        // Other error
        throw new Error(error.message || "Đã có lỗi xảy ra");
      }
    }
  };
};

// Wrapped API functions with error handling
export const mapZnsAPIWithErrorHandling = {
  getMapZnss: withErrorHandling(mapZnsAPI.getMapZnss),
  getEventZnsAll: withErrorHandling(mapZnsAPI.getEventZnsAll),
  createMapZns: withErrorHandling(mapZnsAPI.createMapZns),
  updateMapZns: withErrorHandling(mapZnsAPI.updateMapZns),
  deleteMapZns: withErrorHandling(mapZnsAPI.deleteMapZns),
  sendOneZns: withErrorHandling(mapZnsAPI.sendOneZns),
  sendAllZns: withErrorHandling(mapZnsAPI.sendAllZns),
  sendAllParent: withErrorHandling(mapZnsAPI.sendAllParent),
  resendOneZns: withErrorHandling(mapZnsAPI.resendOneZns),
  resendAllZns: withErrorHandling(mapZnsAPI.resendAllZns),
  resendAllParent: withErrorHandling(mapZnsAPI.resendAllParent),
  sendableCount: withErrorHandling(mapZnsAPI.sendableCount),
  sendableCountParent: withErrorHandling(mapZnsAPI.sendableCountParent),
  getHistories: withErrorHandling(mapZnsAPI.getHistories),
  getTemplate: withErrorHandling(mapZnsAPI.getTemplate),
  getAvailableVariableAliases: withErrorHandling(mapZnsAPI.getAvailableVariableAliases),
  sendOneCampaignZns: withErrorHandling(mapZnsAPI.sendOneCampaignZns),
  sendAllCampaignZns: withErrorHandling(mapZnsAPI.sendAllCampaignZns),
  sendAllParentCampaign: withErrorHandling(mapZnsAPI.sendAllParentCampaign),
};

export default mapZnsAPI;
